import React, { Fragment, useState, useEffect } from "react";
import { FaSpinner, FaPlus } from "react-icons/fa";
import classNames from "classnames";

import useModal from "../../Hooks/useModal";
import StreetViewIcon from "../../../global/img/StreetViewIcon";
import PopupMenu from "../PopupMenu";
import "./ApplicationDocuments.scss";
import util from "../../../global/utils/Helpers";
import getpdf from "../../Utils/PDFLink";
import Button from "../UI/Button";

function ApplicationDocuments(props) {
  let [docs, setDocs] = useState([]);
  const [errors, setErrors] = useState({
    overall: "",
  });

  const { toggleModal, modalLoading } = useModal();

  useEffect(() => {
    setDocs([]);
  }, []);

  const pushDocuments = (new_docs) => {
    let {
      formApi,
      schemaProps: { machine_name },
    } = props;

    new_docs.forEach(function (doc) {
      formApi.mutators.push(machine_name, Object.assign({}, doc));
    });
  };

  const addDocumentButton = () => {
    let callbacks = {
      pushDocuments,
    };
    const btnStyles = {
      marginTop: "15px",
      float: "left",
    };

    const iconStyles = {
      marginRight: "5px",
      marginTop: "1px",
      float: "left",
    };
    return (
      <a
        href
        class="usa-link"
        type="button"
        style={btnStyles}
        onClick={() => {
          toggleModal(
            "applicationDocumentsModal",
            "content",
            null,
            callbacks,
            props
          );
        }}
      >
        {modalLoading ? (
          <FaSpinner style={iconStyles} className="icon-spin" />
        ) : (
          <FaPlus style={iconStyles} className="icon-add" />
        )}
        Add Document(s)
      </a>
    );
  };

  const getDropDown = (docField, fileTypes) => {
    let placeholder = "-Select-";
    let inputRowClasses = classNames("form-row-dimension", "margin-top-0", {
      [`mobile-lg:grid-col-12`]: true,
    });
    let inputClasses = classNames("usa-select", {
      "usa-input-error": false,
      "usa-input-disabled": false,
    });

    return (
      <div className={inputRowClasses}>
        <select
          id="typeOfFile"
          name={docField?.document_name}
          className={inputClasses}
          onChange={(e) => {
            docField.fileType = e.target.value;
          }}
        >
          <option key={-1} value={placeholder}>
            {placeholder}
          </option>
          {fileTypes.map((item, index) => {
            return (
              <option key={index} value={item}>
                {item}
              </option>
            );
          })}
        </select>
      </div>
    );
  };

  const showActions = (doc, fileUploadLocation, index) => {
    const path = window.location.pathname.split("/");
    let formId = path[3];
    let appId = path[4];
    const {
      schemaProps: { isDeletable },
    } = props;

    let apiIndex = util.isLocalhost()
      ? `http://localhost:9393/auth/document/ef/${formId}/${appId}`
      : `${util.getCurrentHost()}/auth/auth/document/ef/${formId}/${appId}`;

    let documentPath = encodeURIComponent(doc.document_path);
    let url = util.isLocalhost()
      ? `${apiIndex}/?path=${process.env.REACT_APP_CASE_CONFIG_DIRECTORY}${documentPath}`
      : `${apiIndex}/?path=/data${documentPath}`;
    return (
      <PopupMenu
        trigger={
          <button type="button" className="btn-app-docs modal-empty-button">
            {" "}
            <b>. . .</b>{" "}
          </button>
        }
        position="bottom right"
        closeOnDocumentClick
        contentStyle={{ padding: "8px", border: "1px", width: "140px" }}
      >
        <div className="menu">
          <a
            href={url}
            rel="noopener noreferrer"
            target="_blank"
            tabIndex={-1} // button will capture keyboard tab focus already
          >
            <button
              className="menu-item menu-item-button dropdown-label-View"
              type="button" // This removes default submit
            >
              View
            </button>
          </a>
          {fileUploadLocation === "application_documents" || isDeletable ? (
            <div className="dropdown-seperator" />
          ) : (
            ""
          )}

          {fileUploadLocation === "application_documents" || isDeletable ? (
            <button
              className="menu-item menu-item-button dropdown-label-View"
              type="button" // This removes default submit
              onClick={() => {
                handleDeleteRequest(doc, index);
              }}
            >
              <span style={{ color: "#9C1712" }}>Remove</span>
            </button>
          ) : null}
        </div>
      </PopupMenu>
    );
  };

  const handleDeleteRequest = (doc, index) => {
    const {
      formApi,
      addPageErrored,
      schemaProps: { machine_name, requiredDocuments },
    } = props;

    let fileIsRequired = requiredDocuments?.includes(doc.machine_name);
    let fieldIsEmpty =
      props.input.value.filter((file) => file.machine_name === doc.machine_name)
        .length <= 1;
    if (fileIsRequired && fieldIsEmpty) {
      addPageErrored(doc.page_index);
    }

    formApi.mutators.remove(machine_name, index);
    let _finalDocs = docs.filter((document) => document.name !== doc.name);
    setDocs(_finalDocs);
  };

  const LinkedPDFButton = () => {
    const [pdfLoading, setPDFLoading] = useState(false);

    const handleGetPDF = async (value) => {
      setPDFLoading(true);
      let response = await getpdf(value);
      setPDFLoading(false);
    };

    //Not a shared component and formType is never passed in, therefore logic will be stored here
    const formType = window.location.pathname.split("/")[3];
    let linkedPW = formType === "9089" && formValues?.jobOppPWDNumber;

    return linkedPW ? (
      <div style={{ marginTop: "25px" }}>
        <Button onClick={() => handleGetPDF(linkedPW)}>Linked 9141</Button>
        {!!pdfLoading && (
          <div style={{ paddingTop: "0.75em" }}>
            <FaSpinner className="icon-spin" />
          </div>
        )}
      </div>
    ) : null;
  };

  const DocumentRow = (doc, index) => {
    const path = window.location.pathname.split("/");
    let formType = path[3];

    let fileTypes = [];

    switch (formType) {
      case "9142A":
        fileTypes = [
          "Documentation of Fixed-Site Agricultural Business",
          "Fixed Site Agricultural Business Transportation Documentation",
          "Attorney G-28 or Agent Documentation",
          "Employer-Provided or Range Housing Documentation",
          "Workers' Compensation Insurance or Other Coverage Documentation",
          "Rental or Public Accommodation Housing Documentation",
          "Other Supporting Documentation",
        ];
        break;
      case "9141":
      case "9089":
        fileTypes = ["Other Supporting Documentation"];
        break;
      case "9142B":
        fileTypes = ["Other Supporting Documentation"];
      default:
    }

    let fileType = doc.machine_name
      .replace(/_/g, " ")
      .toLowerCase()
      .split(" ")
      .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
      .join(" ");
    return (
      <tr key={index}>
        <td>{doc.document_name}</td>
        <td>
          {doc.fileType !== "Application Documents"
            ? doc.fileType
              ? doc.fileType
              : fileType
            : getDropDown(doc, fileTypes)}
        </td>
        <td className="actions-col">
          <div style={{ display: "grid", placeItems: "center" }}>
            {showActions(doc, doc.machine_name, index)}
          </div>
        </td>
      </tr>
    );
  };

  const {
    widget,
    shouldHide,
    readOnly,
    input,
    onChangeCallback,
    formValues,
    schemaProps: { modal },
  } = props;
  const { overall } = errors;

  let wrapperClass = classNames("grid-gap", {
    "input-hide": shouldHide === true,
  });

  let containerClass = classNames("mobile:grid-col-12", "grid-col-12");
  let current_documents = formValues && formValues.files;
  let current_documents_count = current_documents
    ? current_documents.length
    : 0;

  const EmptyState = (props) => {
    return (
      <div className="zero-state">
        <div className="content">
          <div className="folder-circle">
            <StreetViewIcon color={"#FFFFFF"} />
          </div>
          <h3 className="heading">You have no documents.</h3>
          <h4 className="message">Additional documents will appear here.</h4>
        </div>
      </div>
    );
  };

  return (
    <Fragment>
      <div className={wrapperClass}>
        <div className={containerClass}>
          <textarea
            disabled={readOnly || shouldHide}
            {...input}
            hidden
            id={input.name}
            onChange={(e) => {
              input.onChange(e);
              onChangeCallback(e.target.value, props);
            }}
            type={widget}
          />

          <p className="text-secondary-dark">{overall}</p>

          <h4>{`${current_documents_count} Uploaded Documents`}</h4>

          <table className="usa-table margin-bottom-1">
            <thead>
              <tr>
                <th scope="col">Filename</th>
                <th scope="col">Category</th>
                <th scope="col" className="actions-col">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {current_documents_count > 0 ? (
                <>
                  {current_documents_count > 0
                    ? current_documents.map((doc, index) => {
                        return DocumentRow(doc, index);
                      })
                    : null}
                </>
              ) : null}
            </tbody>
          </table>
          {current_documents_count <= 0 ? <EmptyState /> : null}
          {modal ? addDocumentButton() : null}
          <LinkedPDFButton />
        </div>
      </div>
    </Fragment>
  );
}

export default ApplicationDocuments;
